import { AnyAction } from 'redux';
import { SignInitResponse } from '../../class/class';
import { ReduxAction } from '../../enums/const-enums';
import { setDocumentLanguage } from '../../utils/utils';
import { ConfigState } from '../reducers/config-reducer';

export const initConfig = (config: ConfigState): AnyAction => {
  return {
    type: ReduxAction.CONFIG_INIT,
    payload: config,
  };
};

export const signInit = (signInitResponse: SignInitResponse): AnyAction => {
  return {
    type: ReduxAction.SIGN_INIT,
    payload: {
      language: signInitResponse.summary.summary_lang,
      summary: signInitResponse.summary.summary_text,
      summaryCss: signInitResponse.summary.summary_css,
      displayType: signInitResponse.display_type,
    },
  };
};

export const switchLanguage = (language: string): AnyAction => {
  setDocumentLanguage(language);
  return {
    type: ReduxAction.SWITCH_LANGUAGE,
    payload: { language },
  };
};

export const uiReady = (): AnyAction => {
  return {
    type: ReduxAction.UI_READY,
  };
};

export const noSignInit = (): AnyAction => {
  return {
    type: ReduxAction.NO_SIGN_INIT,
  };
};
